import { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { PeopleFill, ShieldFillCheck, WalletFill } from 'react-bootstrap-icons'
import { isUserLoggedIn } from '../helpers'
import { t } from '../locale'
import { fetchActiveClientsCount } from '../service/client'
import { fetchAmlSearchCountThisMonth } from '../service/subscription'
import { useSubscription } from '../context/SubscriptionContext'

function HomeStatsCards() {
  const { credit } = useSubscription()
  const [activeClientsCount, setActiveClientsCount] = useState<number | null>(null)
  const [amlCheckCountMonth, setAmlCheckCountMonth] = useState<number | null>(null)

  useEffect(() => {
    if (!isUserLoggedIn()) return

    fetchActiveClientsCount().then(setActiveClientsCount)
    fetchAmlSearchCountThisMonth().then(setAmlCheckCountMonth)
  }, [])

  return (
    <Row className='mb-2'>
      <Col className='text-center border rounded p-4 bg-white shadow-sm'>
        <PeopleFill size={28} className='text-primary align-middle' />
        <div className='d-inline-block text-start align-middle ms-4'>
          <div className='text-muted small'>{t('activeClients')}</div>
          <div className='display-8 fw-bold text-primary'>{activeClientsCount ?? '—'}</div>
        </div>
      </Col>
      <Col className='ms-2 text-center border rounded p-4 bg-white shadow-sm'>
        <ShieldFillCheck size={28} className='text-primary align-middle' />
        <div className='d-inline-block text-start align-middle ms-4'>
          <div className='text-muted small'>{t('amlChecksThisMonth')}</div>
          <div className='display-8 fw-bold text-primary'>{amlCheckCountMonth ?? '—'}</div>
        </div>
      </Col>
      <Col className='ms-2 text-center border rounded p-4 bg-white shadow-sm'>
        <WalletFill size={28} className='text-primary align-middle mb-4' />
        <div className='d-inline-block text-start align-middle ms-4 '>
          <div className='text-muted small'>{t('pointsAvailable')}</div>
          <div className='display-8 fw-bold text-primary'>{credit || '—'}</div>
        </div>
      </Col>
    </Row>
  )
}

export default HomeStatsCards
